module.exports = __webpack_public_path__ + "img/img-success-open-store.9231ee0f.png";